import { BRAND_PREBOOK_FIELDS_UPDATE } from "constants/action-types";

export const updatePrebookFields = (fields) => ({
    payload: fields,
    type: BRAND_PREBOOK_FIELDS_UPDATE,
});
